export default {
  priv: 'pr_manage',
  overviewTitle: 'Firma\'s',
  detailTitle: 'Firma',
  deleteTitle: 'deze firma',
  url: '/manage/companies',
  apiUrl: '/companies/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'companies',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Actief', value: 'is_active', type: 'boolean'}
  ],
  newRecord: {
    is_active: true
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Naam', value: 'name', link: '/manage/companies/{id}', width: '10%'},
    {text: 'BTW nr', value: 'vatnr', width: '10%'},
    {text: 'Omschrijving', value: 'description', width: '10%'},
    {text: 'IBAN nr', value: 'bankaccount', width: '10%'},
    {text: 'Actief', value: 'is_active', type: 'boolean', width: '2%'},
    {text: 'Boekhoud email', value: 'accounting_email', width: '10%'},
    {text: 'Bonnen email', value: 'transportvoucher_email', width: '10%'},
    {text: 'Bonnen', value: 'is_app_transportvoucher', type: 'boolean', width: '10%'}
  ]
};
